export const titles = [
    { value: 'mr', label: 'Mr' },
    { value: 'ms', label: 'Ms' },
    { value: 'mrs', label: 'Mrs' },
    { value: 'miss', label: 'Miss' },
    { value: 'doctor', label: 'Doctor' },
    { value: 'professor', label: 'Professor' },
    { value: 'sir', label: 'Sir' },
    { value: 'lord', label: 'Lord' },
    { value: 'lady', label: 'Lady' },
    { value: 'baron', label: 'Baron' },
    { value: 'baroness', label: 'Baroness' },
    { value: 'rev', label: 'Reverend' }
];

export const titlesDE = [
    { value: 'herr', mappedValue: 'mr', label: 'Herr' },
    { value: 'frau', mappedValue: 'mrs', label: 'Frau' }
];
